import { render, staticRenderFns } from "./LinkExpense.vue?vue&type=template&id=d7022858&scoped=true"
import script from "./LinkExpense.vue?vue&type=script&lang=ts"
export * from "./LinkExpense.vue?vue&type=script&lang=ts"
import style0 from "./LinkExpense.vue?vue&type=style&index=0&id=d7022858&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7022858",
  null
  
)

export default component.exports